export default "__VITE_ASSET__C41QJ6u6__"